import type { TPickUpPointApi } from '@/components/AdminPanel/Auto/Brands/types';

import type {
  IAcceptResponse,
  IBankResponse,
  ILeasingResponse,
  IRequest,
  IRequestInfo,
  IRequestInitialInfo,
  IRequestProduct,
  ISendRequest
} from '../AutoCredit/types/api.types';
import { ClientApi } from './client.api';

class ClientAutoCreditApi extends ClientApi {
  async getAutoCreditRequest(requestId: string): Promise<IRequestInfo> {
    const response = await this.call<unknown, IRequestInitialInfo>({
      path: `online/requests/${requestId}`
    });

    // Если заявка отклонена клиентом, тогда используем актуальный статус а не приоритетный
    const shouldUseTopResponseStatus =
      response.status?.code !== 'cancelled' && response.top_response_status;
    return {
      ...response,
      status: shouldUseTopResponseStatus || response.status
    };
  }

  sendAutoCreditRequest(requestId: string, body: ISendRequest) {
    return this.call({
      path: `online/requests/${requestId}/send`,
      method: 'post',
      body
    });
  }

  getRequests(): Promise<IRequest[]> {
    return this.call({ path: 'online/requests' });
  }

  getResponses(requestId: string): Promise<{
    Leasings: ILeasingResponse[];
    RequestsProducts: IRequestProduct[];
    Responses: IBankResponse[];
  }> {
    return this.call({
      path: `online/requests/${requestId}/responses`
    });
  }

  extendBookingTime(requestId: string): Promise<void> {
    return this.call({
      path: `online/requests/${requestId}/extend-booking`,
      method: 'post'
    });
  }

  getForteStatus(
    extUuid: string,
    controlClientDecision = false
  ): Promise<unknown> {
    return this.call({
      path: `responses/forte/${extUuid}${controlClientDecision ? `_${controlClientDecision}` : ''}/status`,
      baseUrl: process.env.REACT_APP_AUTH_URL
    });
  }

  // uploadDocument(
  //   requestId: string,
  //   body: Partial<Record<FILE_TYPE, { name: string; base64: string }>>
  // ): Promise<void> {
  //   return this.call({
  //     path: `online/requests/${requestId}/upload-id-card`,
  //     method: 'post',
  //     body
  //   });
  // }

  acceptResponse(data: IAcceptResponse) {
    return this.call({
      path: `online/requests/${data.requestId}/responses/${data.responseId}/${data.offeredUuid || 'none'}/accept`,
      method: 'post'
    });
  }

  setDeliveryType(
    requestId: string,
    body: { pickUpMethodCode: number; pickUpPointId?: string }
  ) {
    return this.call({
      path: `online/requests/${requestId}/pick-up-points`,
      method: 'patch',
      body
    });
  }

  getPickUpPoints(requestId: string): Promise<TPickUpPointApi[]> {
    return this.call({ path: `online/requests/${requestId}/pick-up-points` });
  }

  uploadDocuments(
    requestId: string,
    body: {
      plateNumber?: string;
      files: Array<{ type: string; base64: string; extension?: string }>;
    }
  ) {
    return this.call({
      path: `online/requests/${requestId}/upload-documents`,
      method: 'post',
      body
    });
  }

  rejectRequest(requestId: string) {
    return this.call({
      path: `online/requests/${requestId}/reject`,
      method: 'post'
    });
  }

  sendToAllBanks(requestId: string): Promise<unknown> {
    return this.call({
      path: `online/requests/${requestId}/resend`,
      method: 'post'
    });
  }
}

export const clientAutoCreditApi = new ClientAutoCreditApi();
